import { getFullName } from "shared/utils/get-full-name";
import { Applicant } from "shared/types";

export const getApplicantNames = (applicants: Applicant[]): string => {
  return applicants.length
    ? applicants
        .map((applicant) =>
          getFullName({
            firstName: applicant.first_name,
            lastName: applicant.last_name,
            middleName: applicant.middle_name,
            short: true
          })
        )
        .join(", ")
    : "";
};
export const getInviteesEmails = (
  pendingMagicLinks: { email: string }[]
): string => {
  return pendingMagicLinks.map((ml) => ml.email).join(", ");
};

const getCombinedNamesAndEmails = (
  applicantNames: string,
  inviteesEmails: string
): string => {
  if (applicantNames && inviteesEmails)
    return `${applicantNames}, ${inviteesEmails}`;

  if (applicantNames) return applicantNames;

  return inviteesEmails;
};

export const formatCombinedNamesAndEmails = (
  applicantNames: string,
  inviteesEmails: string
): string => {
  const combined = getCombinedNamesAndEmails(applicantNames, inviteesEmails);
  const people = combined.split(", ");

  return people.length > 2 ? `${people.slice(0, 2).join(", ")}...` : combined;
};
